import * as React from "react"
import { gql } from "@apollo/client"
import { Flex, LinkBox, LinkOverlay, Stack, Text } from "@chakra-ui/react"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import { CompetitionItemFragment } from "lib/graphql"
import { transformImage } from "lib/helpers/utils"

dayjs.extend(utc)

const _ = gql`
  fragment CompetitionItem on Competition {
    id
    name
    slug
    region
    deadline
    isLive
    firstRoundDate
    year
    isAttending
    thumbnail
  }
`

interface Props {
  competition: CompetitionItemFragment
}

export const CompetitionTile: React.FC<Props> = ({ competition }) => {
  return (
    <LinkBox 
      position="relative" 
      overflow="visible"
    >
      <LinkOverlay 
        href={`/wedstrijd/${competition.slug}`} 
        textDecoration="none"
        display="block"
        aria-label={`View competition ${competition.name}`}
        tabIndex={0}
        _focus={{
          boxShadow: "0 0 0 3px var(--chakra-colors-blue-300)",
          outline: "none",
        }}
        _focusVisible={{
          boxShadow: "0 0 0 3px var(--chakra-colors-blue-300)",
          outline: "none",
        }}
      >
        <Stack
          width="100%"
          py={6}
          px={4}
          borderRadius="md"
          bg="gray.700"
          minH="330px"
          justify="space-between"
          overflow="hidden"
          _before={{
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            bgImage: `
              linear-gradient(
                rgba(24, 24, 27, 0.55), 
                rgba(8, 8, 10, 0.55)
              ),
              url('${transformImage(competition?.thumbnail, "h_500") || ""}')
            `,
            role: "img",
            ariaLabel: "wedstrijd image",
            opacity: 1,
            bgSize: "cover",
            bgRepeat: "no-repeat",
            zIndex: 0,
            borderRadius: "md",
          }}
        >
          {competition.isAttending && (
            <Flex
              zIndex={1}
              w="100%"
              bgColor="pink.500"
              position="absolute"
              top={0}
              left={0}
              borderTopRadius="md"
              px={4}
              py={1}
              justify="center"
            >
              <Text color="black" fontWeight="bold">
                Aangemeld
              </Text>
            </Flex>
          )}
          <Stack zIndex={1}>
            <Text
              fontWeight="extrabold"
              fontSize="4xl"
              textTransform="uppercase"
              lineHeight="short"
              mb={2}
              color="white"
            >
              {competition.name}
            </Text>
            <Text fontWeight="bold" fontSize={22} color="yellow.500">
              {competition.firstRoundDate
                ? dayjs.utc(competition.firstRoundDate).format("DD/MM/YYYY")
                : "Datum volgt"}
            </Text>
          </Stack>
        </Stack>
      </LinkOverlay>
    </LinkBox>
  )
}
